// extracted by mini-css-extract-plugin
module.exports = {"feedback-tab":"Feedback_feedback-tab__tvXhu","desc":"Feedback_desc__2u1oE"};